<template>
	<div class="gotop">
		<div class="go-btn" id="toTop" @click="toTop" v-if="isActive">
			<img src="https://caifung.oss-cn-hangzhou.aliyuncs.com/official/arrow.png">
		</div>
	</div>
</template>

<script>
 let timer = null //定义初始值
	export default{
		props:{
      step:{   //此数据是控制动画快慢的
        type:Number,
        default:100
      }
    },
		data(){
			return{
				isActive:false,
				isTop:false
			}
		},
		methods:{
      toTop(){ // 动画

         timer = setInterval(function () {
          let osTop = document.documentElement.scrollTop || document.body.scrollTop
          let ispeed = Math.floor(-osTop / 5)
          document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed
          this.isTop = true
          if (osTop === 0) {
            clearInterval(timer)
          }
        },30)

      },
    },
		created(){
      let vm =this;
      window.onscroll=function(){
        if (document.documentElement.scrollTop>60) {
          vm.isActive=true;
        }else {
          vm.isActive=false;
        }
      }
    }
	}
</script>

<style scoped>
	.go-btn{
		width: 52px;
		position: fixed;
		right: 30px;
		bottom: 200px;
		cursor: pointer;
	}
	.go-btn img{
		display: block;
		width: 100%;
	}



</style>



// WEBPACK FOOTER //
// src/components/gotop.vue